import React from 'react';
import { Menu } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuTrigger,
} from 'shadcn/components/ui/DropdownMenu';

export function CrossDockPurchaseOrderActionsMenu({
    ariaLabel = 'Open actions menu',
    isCancelDisabled = false,
    isDownloading = false,
    onCancel = () => {},
    onDownloadPdf,
}) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" aria-label={ariaLabel}>
                    <Menu className="h-4 w-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {onDownloadPdf ? (
                    <DropdownMenuSub>
                        <DropdownMenuSubTrigger disabled={isDownloading}>Download</DropdownMenuSubTrigger>
                        <DropdownMenuSubContent>
                            <DropdownMenuItem onSelect={onDownloadPdf} disabled={isDownloading}>
                                PDF
                            </DropdownMenuItem>
                        </DropdownMenuSubContent>
                    </DropdownMenuSub>
                ) : null}
                {onDownloadPdf ? <DropdownMenuSeparator /> : null}
                <DropdownMenuItem variant="destructive" onSelect={onCancel} disabled={isCancelDisabled}>
                    Cancel PO
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

CrossDockPurchaseOrderActionsMenu.displayName = 'CrossDockPurchaseOrderActionsMenu';
